import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/lib/auth-context'
import type { Role } from '@/types'

interface RoleGateProps {
  children: ReactNode
  /** Si se omite, solo exige estar autenticado (cualquier rol). */
  role?: Role | Role[]
}

export function RoleGate({ children, role }: RoleGateProps) {
  const { auth } = useAuth()

  if (!auth) return <Navigate to="/login" replace />

  if (role) {
    const allowed = Array.isArray(role) ? role : [role]
    if (!allowed.includes(auth.role)) return <Navigate to="/admin/ventas/nueva" replace />
  }

  return <>{children}</>
}
